import { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { categories } from '@/data/categories';

export default function CategoryDropdown() {
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClick(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, []);

  return (
    <div ref={ref} className="relative w-full">
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        className="flex w-full items-center justify-between gap-3 rounded-md border border-background-200 bg-white px-4 py-3 text-left text-sm font-medium text-foreground-950 transition-colors hover:bg-background-100 cursor-pointer"
      >
        <span className="flex items-center gap-2">
          <i className="ri-list-check-3 text-lg leading-none text-primary-600"></i>
          <span className="whitespace-nowrap">{t('home.hero.categoryLabel')}</span>
        </span>
        <i className={`ri-arrow-down-s-line text-lg leading-none text-foreground-500 transition-transform ${open ? 'rotate-180' : ''}`}></i>
      </button>

      {open && (
        <div className="absolute left-0 right-0 top-full z-30 mt-2 max-h-80 overflow-y-auto rounded-lg border border-background-200 bg-background-50">
          {categories.map((category) => (
            <a
              key={category.key}
              href={category.url}
              target="_blank"
              rel="noopener nofollow"
              className="flex items-center justify-between gap-3 px-3 py-2 text-sm text-foreground-800 transition-colors hover:bg-background-100"
            >
              <span className="flex items-center gap-3">
                <img
                  src={category.image}
                  alt={t(category.key)}
                  className="h-9 w-9 shrink-0 rounded object-cover"
                />
                <span className="whitespace-nowrap">{t(category.key)}</span>
              </span>
              <i className="ri-arrow-right-up-line text-base leading-none text-foreground-400"></i>
            </a>
          ))}
        </div>
      )}
    </div>
  );
}